import React from 'react';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const Hero: React.FC = () => {
  return <div className="w-full relative overflow-hidden min-h-[60vh] flex items-center pt-32 pb-20" data-id="element-472" data-mp="eilej673gxdk">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/joW23QukC9PHBnWHCKRxNE/Container_(2).png" alt="Het team van Noord Digital in Oudkarspel" className="absolute inset-0 w-full h-full object-cover" data-id="element-473" data-mp="4lqjixa15f41" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#004AC7]/60 via-[#003A9E]/50 to-black/55 mix-blend-multiply" data-id="element-474" data-mp="xae7x1q2sklt"></div>
      <div className="absolute inset-0 bg-[#004AC7]/20" data-id="element-475" data-mp="sai3j1dgur5q"></div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-476" data-mp="nc88cqrqrqk4">
        <div className="max-w-4xl mx-auto text-center" data-id="element-477" data-mp="nekm0rqgverd">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-478" data-mp="3d2bkbqsid1w2">
            <div className="inline-flex items-center gap-2 text-white/90 text-sm font-medium mb-6" data-id="element-479" data-mp="3j6fylr125fed">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-480" data-mp="3o5j3nbh1flmc" />
              Oudkarspel, gemeente Dijk en Waard
            </div>

            <h1 className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl drop-shadow-lg" data-id="element-481" data-mp="3e963buqzm9im">
              Online gevonden worden en er professioneel uitzien
            </h1>

            <p className="text-gray-100 mb-10 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto drop-shadow-md" data-id="element-482" data-mp="358howyxom757">
              Jouw klant zoekt online, ook als hij bij je om de hoek woont.
              Wij zorgen dat je op dat moment gevonden wordt en dat je bedrijf
              er dan uitziet zoals het werk dat je levert. Je website en je
              vormgeving zijn daarvoor het middel, geen doel op zich.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-483" data-mp="2ljgz78izdtcs">
              <a href="#contact" className="inline-flex items-center justify-center bg-[#004AC7] hover:bg-[#003A9E] text-white font-bold py-4 px-8 rounded-lg transition-colors duration-200 shadow-lg group" data-id="element-484" data-mp="s2b8o0ipgn67">
                Plan een kennismaking
                <ArrowRightIcon className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200" data-id="element-485" data-mp="ia5imwc0kftn" />
              </a>
              <a href="#services" className="inline-flex items-center justify-center bg-white/10 border border-white/40 text-white font-semibold py-4 px-8 rounded-lg hover:bg-white/20 transition-colors duration-200" data-id="element-486" data-mp="1b1fez1iv42u6">
                Bekijk wat we doen
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};